import React from "react";
import { Footer } from "@excalidraw/excalidraw/index";

export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    return (
      <Footer>
        <div
          style={{
            display: "flex",
            gap: ".5rem",
            alignItems: "center",
          }}
        >
          {/*symmedia custom - remove encrypted icon and link*/}
          {/*isVisualDebuggerEnabled() && <DebugFooter onChange={onChange} />*/}
          {/*isExcalidrawPlusSignedUser ? (
            <ExcalidrawPlusAppLink />
          ) : (
            <EncryptedIcon />
          )*/}
        </div>
      </Footer>
    );
  },
);
